import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ManagementReportExecutionService } from '@core/services/entities/management-report-execution.service';
import { CreateManagementReportExecutionRequestDto } from '@domain/management-report-execution/dtos/create-management-report-execution.request.dto';
import { ListManagementReportExecutionRequestDto } from '@domain/management-report-execution/dtos/list-management-report-execution.request.dto';
import { ManagementReportExecutionResponseDto } from '@domain/management-report-execution/dtos/management-report-execution.response.dto';
import { PreviewManagementReportExecutionResponseDto } from '@domain/management-report-execution/dtos/preview-management-report-execution.response.dto';
import { ManagementReportExecutionRepository } from '@domain/management-report-execution/repositories/management-report-execution.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementReportExecutionRepositoryService implements ManagementReportExecutionRepository {
  constructor(
    private managementReportExecutionService: ManagementReportExecutionService,
  ) {}

  list(
    request: ListManagementReportExecutionRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<ManagementReportExecutionResponseDto>>
  > {
    return this.managementReportExecutionService.list(request);
  }

  show(
    request: RefId,
  ): Observable<ApiResponse<ManagementReportExecutionResponseDto>> {
    return this.managementReportExecutionService.show(request);
  }

  create(
    request: CreateManagementReportExecutionRequestDto,
  ): Observable<ApiResponse<ManagementReportExecutionResponseDto>> {
    return this.managementReportExecutionService.create(request);
  }

  download(request: RefId): Observable<ApiResponse<{ viewUrl: string }>> {
    return this.managementReportExecutionService.download(request);
  }

  preview(
    request: RefId,
  ): Observable<ApiResponse<PreviewManagementReportExecutionResponseDto>> {
    return this.managementReportExecutionService.preview(request);
  }

  delete(request: RefId): Observable<ApiResponse<void>> {
    return this.managementReportExecutionService.delete(request);
  }
}
